import { render, staticRenderFns } from "./SubDevelopments.vue?vue&type=template&id=5ead654e"
import script from "./SubDevelopments.vue?vue&type=script&lang=js"
export * from "./SubDevelopments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports